import { FC } from 'react';
import { ResetButton } from '~/shared/components/Button/ResetButton';
import ChevronIcon from '~/icons/chevron.svg';
import { useTranslation } from '~/shared/utils/translation';
import { useSalesOfferGroups } from '~/features/productList/hooks/useSalesOfferGroups';
import { preDefinedAttributes } from '../preDefinedAttributes';
import styles from './FilterListRow.module.scss';

type SalesOffersFilterListRowProps = {
    onSelect: (attribute: string) => void;
};

// Own row component so useSalesOfferGroups (a live Algolia widget) mounts once, not once per facet row.
export const SalesOffersFilterListRow: FC<SalesOffersFilterListRowProps> = ({ onSelect }) => {
    const { translate } = useTranslation();
    const { selectedCount } = useSalesOfferGroups();
    const selectedLabel =
        selectedCount > 0 ? translate('plp.selectedFacets', { count: `${selectedCount}` }) : null;

    return (
        <ResetButton
            className={styles.row}
            onClick={() => onSelect(preDefinedAttributes.newsToggles)}
        >
            {translate('plp.facet.preDefinedNewsToggles')}

            <span className={styles.facetContainer}>
                {selectedLabel && <span className={styles.countPill}>{selectedLabel}</span>}
                <ChevronIcon className={styles.chevron} />
            </span>
        </ResetButton>
    );
};
